<template>
    <main class="content-partners">
        <section class="content-partners-description container">
            <div class="content-partners-description-title">
                <h1>{{ text.title }}</h1>
            </div>
            <div class="content-partners-description-text">
                <p v-html="text.description"></p>
            </div>
        </section>
    </main>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: ["text"],
};
</script>
<style lang="scss" scoped>
.content-partners {
    margin-top: 8rem;
    background-color: #f3f8f4;
    &-description {
        &-title {
            h1 {
                text-align: left;
                font-size: 4rem;
                font-weight: bold;
                color: #338545;
                padding-block: 6rem 5rem;
                margin: 0;
            }
        }
        &-text {
            p {
                text-align: left;
                font-family: "Font Regular";
                font-size: 2.8rem;
                color: #112d23;
                padding-bottom: 9rem;
                margin: 0;
            }
        }
    }
}
</style>
